module.exports = __webpack_public_path__ + "img/data-science-icon-animation-banner-clockwise.ff690aab.gif";